import { useSnowplowContext } from "@simplybusiness/services";
import { Link, Text } from "@simplybusiness/mobius";
import type { ReferralTextProps } from "./types";

export const ReferralText = (props: ReferralTextProps) => {
  const { firstName, referenceNumber, phoneNumbers, sbDirect, children } =
    props;
  const { snowplow } = useSnowplowContext();

  const handleMobileLinkClick = () => snowplow?.trigger("mobileLinkClick");

  return (
    <div className="mobius-referral__text">
      {sbDirect ? (
        <>
          <Text elementType="h2">Thanks, {firstName}</Text>
          <Text variant="body">
            Based on the information you shared about your business, we are
            searching for quotes offline.
          </Text>
          <Text variant="body">
            One of our licensed agents is ready to work with you to help find
            coverage for your small business.
          </Text>
          <Text variant="body">
            You can speak with them at{" "}
            {/* Should determine where and how contactNumber is formatted */}
            <Link
              id="thank-you-mobile-link-sb"
              href={`tel:${phoneNumbers.contactUs}`}
              onClick={handleMobileLinkClick}
            >
              {phoneNumbers.contactUs}
            </Link>
          </Text>
          {children}
        </>
      ) : (
        <>
          <Text elementType="h2">Thank You!</Text>
          <Text variant="body">
            We appreciate you taking the time to answer our questions.
            We&apos;re using this info right now to see if we can provide you
            with a quote.
          </Text>
          <Text variant="body">
            If we do find a quote, one of our licensed agents will email you or
            call you from {phoneNumbers.contactYou}, so be on the lookout!
          </Text>
          <Text elementType="h3">Don&apos;t want to wait?</Text>
          <Text variant="body">
            We get it - you&apos;re busy! If you want to reach an agent ASAP
            about your insurance quote, give us a call at{" "}
            <Link
              id="thank-you-mobile-link-non-sb"
              href={`tel:${phoneNumbers.contactUs}`}
              onClick={handleMobileLinkClick}
            >
              {phoneNumbers.contactUs}
            </Link>{" "}
            at a time that works best for you.
          </Text>
          <Text variant="body">
            Don&apos;t forget to have your reference number handy - it&apos;s{" "}
            {referenceNumber}.
          </Text>
          <Text variant="body">Thanks again for choosing Simply Business!</Text>
        </>
      )}
    </div>
  );
};
